<template>
    <div class="MemberManagement">
        <div class="header">
            <el-button type="primary" style="margin: 0 0 20px;" @click="clickexport">导出数据</el-button>
            <br/>
            <el-row style="line-height:40px;">
                <el-col :span="1">综合查询</el-col>
                <el-col :span="5">
                    <el-input v-model="params.searchValue" placeholder="订单号、下单人手机号、姓名、身份证号" clearable></el-input>
                </el-col>
                <el-col :span="1" style="margin-left: 20px;">咨询师</el-col>
                <el-col :span="5">
                    <el-input v-model="params.consultantValue" placeholder="咨询师姓名、ID" clearable></el-input>
                </el-col>
                <el-col :span="1" style="margin-left: 20px;">订单状态</el-col>
                <el-col :span="5">
                    <el-select v-model="params.orderStatus" clearable placeholder="请选择" style="width:100%;">
                        <el-option label="未付款" :value="1"></el-option>
                        <el-option label="已付款" :value="2"></el-option>
                        <el-option label="已服务" :value="3"></el-option>
                        <el-option label="已取消" :value="4"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="line-height: 40px;margin-top:20px;">
                <el-col :span="1">下单时间</el-col>
                <el-col :span="6">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="Time"    
                        type="daterange"
                        range-separator="至"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeTime"
                        >
                    </el-date-picker>
                </el-col>
                <el-col :span="6" style="margin-left: 20px;">
                    <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
                    <el-button type="primary" @click="reset">重置表单</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="content">
            <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="OrderList"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange">
                <el-table-column type="selection"> </el-table-column>
                <el-table-column prop="orderId" label="订单号"></el-table-column>
                <el-table-column prop="realName" label="下单人"></el-table-column>
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column prop="idCard" label="身份证号"></el-table-column>
                <el-table-column prop="createTime" label="下单时间"></el-table-column>
                <el-table-column prop="orderStatusCn" label="订单状态" >
                    <template v-slot="scope">
                        <span style="color: #00BFBF;" v-if="scope.row.orderStatusCn=='已付款'">{{ scope.row.orderStatusCn }}</span>
                        <span style="color: #D9001B;" v-else-if="scope.row.orderStatusCn=='未付款'">{{ scope.row.orderStatusCn }}</span>
                        <span style="color: #4B7902;" v-else-if="scope.row.orderStatusCn=='已服务'">{{ scope.row.orderStatusCn }}</span>
                        <span style="color: #AAAAAA;" v-else-if="scope.row.orderStatusCn=='已取消'">{{ scope.row.orderStatusCn }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderAmount" label="付款金额(元)"></el-table-column>
                <el-table-column prop="orderTypeStr" label="服务类型"></el-table-column>
                <el-table-column prop="consultantRealName" label="咨询师"></el-table-column>
                <el-table-column prop="consultantId" label="咨询师ID"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="handle" @click="clickDetail(scope.row)">详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum"
                :page-size="params.pageSize"
                hide-on-single-page
                layout="total, prev, pager, next"
                :total="params.pageTotal">
            </el-pagination>
        </div>

        <!-- 详情弹窗 -->
        <el-drawer
            :visible.sync="drawerDetail"
            size="40%"
            :with-header="false">
            <el-form class="drawerDetail">
                <el-form-item label="订单号：" label-width="90px"><el-input v-model="DetailData.orderId" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="付款人：" label-width="90px"><el-input v-model="DetailData.realName" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="手机号：" label-width="90px"><el-input v-model="DetailData.phone" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="身份证号：" label-width="90px"><el-input v-model="DetailData.idCard" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="下单时间：" label-width="90px"><el-input v-model="DetailData.createTime" disabled clearable style="width: auto;" maxlength="6"></el-input></el-form-item>
                <el-form-item label="订单状态：" label-width="90px"><el-input v-model="DetailData.orderStatusCn" disabled clearable style="width: auto;" maxlength="11"></el-input></el-form-item>
                <el-form-item label="付款金额：" label-width="90px"><el-input v-model="DetailData.orderAmount" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="服务类型：" label-width="90px"><el-input v-model="DetailData.orderTypeStr" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="咨询师：" label-width="90px"><el-input v-model="DetailData.consultantRealName" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="咨询师ID：" label-width="90px"><el-input v-model="DetailData.consultantId" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="drawerDetail=false">确认</el-button>
                    <el-button @click="drawerDetail=false">返回</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </div>
</template>
<script>
export default{
    name:'OrderManagement',
    data() {
        return {
            Time:'',
            params:{
                pageNum:1,
                pageSize:10,
                pageTotal:0,
                searchValue:'',
                consultantValue:'',
                orderStatus:'',
                startOrderTime:'',
                endOrderTime:'',
                orderIds:[]
            },
            DetailData:"",
            drawerDetail:false,
            loading:false,
            OrderList:[]
        }
    },
    created() {
        this.list();
    },
    methods: {
        list(){
            this.loading=true;
            this.$Http_Post('kg/order/list',this.params).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.OrderList=res.Data;
                    this.params.pageTotal=res.Counts;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        changeTime(val){
            if(val==null){
                this.params.startOrderTime='';
                this.params.endOrderTime='';
            }else{
                this.params.startOrderTime=val[0];
                this.params.endOrderTime=val[1];
            }
        },
        handleSelectionChange(val){
            this.params.orderIds=[];
            for(let item of val){
                this.params.orderIds.push(item.orderId);
            }
        },
        handleCurrentChange(val){
            this.params.pageNum=val;
            this.list();
        },
        clickDetail(val){
            this.drawerDetail=true;
            this.DetailData=val;
        },
        clickexport(){
            if(this.params.orderIds.length==0){
                this.$message({type: 'error', message:'请先选择需要导出的数据'});
                return false;
            }
            this.$Http_Post('kg/order/exportOrderList',this.params).then(res=>{
                if(res.Code==0){
                    location.href=process.env.VUE_APP_URL + res.Message;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        // 重置
        reset(){
            this.params=this.$options.data().params;
            this.list();
        }
    },
}
</script>
<style scoped>
.header{background: #fff;padding:20px;margin-bottom: 20px;}
.management{padding:20px;}
.handle{padding:0 10px;color: #4e9cef;cursor: pointer;}
.drawerDetail{margin: 20px;}
.content{background: #fff;padding:20px;}
</style>